import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("Ingresa una dirección de correo electrónico válida")
    .required("Ingresa una dirección de correo electrónico válida"),
  password: yup.string().required("La contraseña es obligatoria"),
});
